'use client';

import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';

const Content = () => {
  return (
    <LayoutGrid>
      <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
        <Typography variant="eyebrow-large" weight="medium">
          CANADA
        </Typography>
        <Typography variant="h3" Element="h1" className="mt-4">
          Innovation, Science and Economic Development Canada (ISED) regulatory
          information
        </Typography>
        <Typography className="my-4">
          This device (20635-OURA1801) complies with Innovation, Science and
          Economic Development Canada's licence-exempt RSS standard(s).
          Operation is subject to the following two conditions: (1) This device
          may not cause interference; and (2) This device must accept any
          interference, including interference that may cause undesired
          operation of the device.
        </Typography>
        <Typography className="my-4">
          Avis de conformité à la réglementation d'Innovation, Sciences et
          Développement économique Canada (ISDE)Le présent appareil
          (20635-OURA1801) est conforme aux CNR d'Innovation, Science et
          Développement économique Canada applicables aux appareils radio
          exempts de licence. L'exploitation est autorisée aux deux conditions
          suivantes: (1) l'appareil ne doit pas produire de brouillage; (2)
          l'utilisateur de l'appareil doit accepter tout brouillage
          radioélectrique subi, même si le brouillage est susceptible d'en
          compromettre le fonctionnement.
        </Typography>
        <Typography variant="h4" Element="h2" className="mt-8">
          RF exposure safety
        </Typography>
        <Typography className="my-4">
          This product is a radio transmitter and receiver. It is designed not
          to exceed the emission limits for exposure to radio frequency (RF)
          energy set by the ISED.
        </Typography>
        <Typography className="my-4">
          This transmitter must not be co-located or operating in conjunction
          with any other antenna or transmitter.
        </Typography>
        <Typography className="my-4">
          Ce produit est un émetteur et un récepteur radio. Il est conçu pour ne
          pas dépasser les limites d'émission pour l'exposition à l'énergie
          radiofréquence (RF) établie par l'ISDE.
        </Typography>
        <Typography className="my-4">
          L'émetteur ne doit pas être colocalisé ni fonctionner conjointement
          avec à autre antenneou autre émetteur.
        </Typography>
        <Typography variant="h4" Element="h2" className="mt-8">
          CAN ICES-3 (B)/NMB-3(B)
        </Typography>
        <Typography className="my-4">
          This Class B digital apparatus complies with Canadian ICES-003 and CAN
          ICES-3 (B)/NMB-3(B).
        </Typography>
        <Typography className="my-4">
          Cet appareil numérique de clase B est conforme à la norme Canadienne
          ICES-003 et CAN ICES-3 (B)/NMB-3(B).
        </Typography>
      </GridItem>
    </LayoutGrid>
  );
};

export default Content;
